const QUERY_KEYS = {
  TABLES: 'TABLES',
};

export default QUERY_KEYS;
